import { render, staticRenderFns } from "./CatalogItemPrice.vue?vue&type=template&id=18afd9b0&"
import script from "./CatalogItemPrice.vue?vue&type=script&lang=ts&"
export * from "./CatalogItemPrice.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogItemPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports